(function () {
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  function setup(root) {
    var input = root.querySelector('[data-brands-search]');
    var clearButton = root.querySelector('[data-brands-clear]');
    var empty = root.querySelector('[data-brands-empty]');
    var items = root.querySelectorAll('[data-brand-item]');
    var groups = root.querySelectorAll('[data-brand-group]');
    var letters = root.querySelectorAll('[data-brand-letter]');
    if (!input || !items.length) return;

    function apply() {
      var query = normalize(input.value);
      var visible = 0;

      items.forEach(function (item) {
        var haystack = normalize(item.getAttribute('data-brand-search') || '');
        var match = query === '' || haystack.indexOf(query) !== -1;
        item.hidden = !match;
        if (match) visible += 1;
      });

      groups.forEach(function (group) {
        var shown = group.querySelectorAll('[data-brand-item]:not([hidden])').length;
        group.hidden = shown === 0;
      });

      letters.forEach(function (letter) {
        var id = letter.getAttribute('href');
        if (!id) return;
        var group = root.querySelector(id);
        var muted = !group || group.hidden;
        letter.classList.toggle('is-muted', muted);
        if (muted) {
          letter.setAttribute('aria-disabled', 'true');
          letter.setAttribute('tabindex', '-1');
        } else {
          letter.removeAttribute('aria-disabled');
          letter.removeAttribute('tabindex');
        }
      });

      if (empty) empty.hidden = visible !== 0;
      if (clearButton) clearButton.hidden = input.value === '';
    }

    input.addEventListener('input', apply);
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        apply();
        input.focus();
      });
    }
    apply();
  }

  document.querySelectorAll('[data-brands-directory]').forEach(setup);
})();
